a.notification = (function(){
	var my = {
		replaceTags:function(str){
			return new EJS({str:str}).render({});
		}
	}
	return my;
}());